import React from 'react';
import ImportReviewMainContent from './ImportReviewMainContent';
import ImportReviewSideSection from './ImportReviewSideSection';

const ImportReviewSelections: React.FC = () => (
  <div className="flex flex-row  w-full h-full overflow-hidden">
    <ImportReviewMainContent />
    <div className="mt-4 border-r border-litlingo-gray-2" />
    <ImportReviewSideSection />
  </div>
);

export default ImportReviewSelections;
